module.exports = __webpack_public_path__ + "img/ears_male.4627f8ab.png";